<tidy-camera-preview (status)="statusChange = $event" (videoUrl)="videoRecorded($event)">
  <div #scanner style="position: absolute"></div>
</tidy-camera-preview>
